import moment from "moment";
import notification from "antd/lib/notification";
import {
  WDQMS_API,
  fetchData,
  isEmpty,
  setError404
} from "./actions";
import {
  setProperty,
  setPeriodDataKey,
  updatePeriodTypes
} from "./actions";
import { loadInitialPeriodsGCOS, loadAllPeriodsGCOS, setCalendarPeriodsGCOS } from "./action_utils";

// GCOS report types
export const GCOS_REPORT_TYPES = {
  gsn: [
    {
      code: "availability",
      description: "Availability"
    },
    {
      code: "completeness", 
      description: "Completeness"
    },
    {
      code: "quality",
      description: "Quality"
    }
  ],
  guan: [
    {
      code: "availability",
      description: "Availability"
    },
    {
      code: "quality",
      description: "Quality"
    }
  ]
};

// Main GCOS data fetching function for guan and gsn file types
export const fetchGcosDataFromApi = (payload, pageType) => {
  // differentiate between requests coming from the map and from the database status
  if (pageType === "DB_STATUS") {
    pageType = "&page_type=DB_STATUS";
  }
  return dispatch => {
    // If we have URL params, set them to the selected
    // params for the menu and map
    if (!isEmpty(payload.params)) {
      dispatch(
        setProperty({
          type: payload.fileType,
          key: "selectedPeriodType",
          value: payload.params.periodType
        })
      );

      dispatch(
        setProperty({
          type: payload.fileType,
          key: "selectedReport",
          value: payload.params.report
        })
      );

      if (payload.params.variable) {
        dispatch(
          setProperty({
            type: payload.fileType,
            key: "selectedVariable",
            value: payload.params.variable
          })
        );
      }

      dispatch(
        setProperty({
          type: payload.fileType,
          key: "selectedDate",
          value: payload.params.date
        })
      );
    }
    if (!payload.alreadyFetched) {
      // Load initial periods (quick fetch to load page faster)
      if (loadInitialPeriodsGCOS(900, pageType, payload, "GCOS", dispatch)) {
        // Load all periods
        loadAllPeriodsGCOS(payload, pageType).then(response => {
          // set calendar periods
          setCalendarPeriodsGCOS(response, dispatch, payload, true);
          dispatch(
            setProperty({
              type: payload.fileType,
              key: "allDataFetched",
              value: true
            })
          );
        });
      }
    }
  };
};

